import styled from 'styled-components';
export const Container = styled.div`
w`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  padding: 10px 20px 50px 0;
`;

export const AlignHeaderContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 15px;
`;

export const FooterContainer = styled.div`
  display: flex;
  gap: 10px;
`;
